// store/sidebarSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./index";

interface SidebarState {
  isExpanded: boolean;
}

const initialState: SidebarState = {
  isExpanded: true,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isExpanded = !state.isExpanded;
    },
    setSidebarExpanded: (state, action: PayloadAction<boolean>) => {
      state.isExpanded = action.payload;
    },
  },
});

export const { toggleSidebar, setSidebarExpanded } = sidebarSlice.actions;

// Selector to get sidebar state from the store
export const selectSidebarExpanded = (state: RootState) =>
  state.sidebar.isExpanded;

export default sidebarSlice.reducer;
